<template>
  <div class="feedbacks">
    <div class="inner_container">
        <div class="close-cross" @click="$emit('closeFeedbacks')">
        </div>
        <div class="title">
            <h2 v-html="texts.feedbackTitle"></h2>
            <p v-html="texts.feedbackSubtitle"></p>
        </div>
        <div class="feedbacks_container" v-if="feedbacks.length">
            <div class="feedback" v-for="feedback in feedbacks" :key="feedback.id">
                <div
                class="feedback__image"
                :style="[feedback.logo ? { 'background-image': `url(${require('@/assets/' + feedback.logo)})` } : '']"></div>
                <p v-html="feedback.content"></p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Hero',
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    state() {
      return this.$root.$data.state;
    },
    texts() {
      return this.state.system.header
    },
    feedbacks() {
      return this.state.feedbacks
    }
  },
  mounted() {
      this.state.showFeedbacks = true;
  },
  beforeDestroy() {
      this.state.showFeedbacks = false;
  },
};
</script>

<style scoped lang="stylus">

@import '../../styles/common.styl'

.feedbacks
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba($OTSnavBlue, 0.5)
    z-index 20
    padding-top 90px
    padding-bottom 40px
    +mobile()
        padding-bottom 1px
    .inner_container
        max-width 1000px
        margin 0 auto
        background-color #f6f6f6
        border-radius 8px
        display flex
        flex-flow column
        height 100%
        position relative
        padding-bottom 10px
        +mobileXS()
            padding-bottom 15px
        .close-cross
            position absolute
            background-image url('../../assets/close-cross.png')
            left auto
            right 20px
            top 20px
            pointer cursor
        .title
            flex 0 0 auto
            text-align center
            padding-top 50px
            padding-bottom 37px
            +mobile()
                padding-bottom 5px
            +mobileXS()
                padding-bottom 15px
            h2
                font-size 30px
                margin .5em 0
                +mobile()
                    margin-top 0
            p
                font-size 24px
        .feedbacks_container
            flex 1 1 auto
            overflow auto
            padding 25px 50px
            color #333
            font-size 14px
            +mobile()
                padding 25px
            +mobileXS()
                padding 0 10px
            .feedback
                background #fff
                margin-bottom 18px
                display flex
                align-items stretch
                padding 30px 45px
                border 1px solid #e4e4e4
                +mobile()
                    flex-flow column
                    padding 25px
                +mobileXS()
                    padding 10px 20px
                &:last-of-type
                    margin-bottom 8px
                .feedback__image
                    width 165px
                    flex 0 0 auto
                    background-repeat no-repeat
                    background-position top center
                    background-size contain
                    margin-right 40px
                    +mobile()
                        height 50px
                        width 100%
                        margin 0
                        margin-bottom 15px
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Feedbacks.vue